import React, { useEffect, useState } from 'react';
import { MdDownloadForOffline } from 'react-icons/md';
import { Link, useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import { client, urlFor } from '../client';
import MasonryLayout from './MasonryLayout';
import { pinDetailMorePinQuery, pinDetailQuery } from '../utils/data';
import Spinner from './Spinner';

import {ethers} from 'ethers';
import { contractABI, contactAddress } from '../utils/constants';
const {ethereum} = window;

const getEthereumContract = () => {
  const provider = new ethers.providers.Web3Provider(ethereum);
  const signer = provider.getSigner();
  const transactionContract = new ethers.Contract(contactAddress,contractABI,signer);

  return transactionContract;
}
// import { TransactionContext } from "../context/TransactionContext";

const Pindetail = ({ user }) => {
  // const { formData, setFormData, handleChange, sendTransaction} = useContext(TransactionContext);
  const { pinId } = useParams();
  const [pins, setPins] = useState();
  const [pinDetail, setPinDetail] = useState();
  const [comment, setComment] = useState('');
  const [addingComment, setAddingComment] = useState(false);
  const [support, setSupport] = useState(false)
  // const [formData, setFormData] = useState({ amount: '', message: '' });
  const [amount, setAmount] = useState(0);
  const [message, setMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  

  const fetchPinDetails = () => {
    const query = pinDetailQuery(pinId);

    if (query) {
      client.fetch(`${query}`).then((data) => {
        setPinDetail(data[0]);
        console.log(data);
        if (data[0]) {
          const query1 = pinDetailMorePinQuery(data[0]);
          client.fetch(query1).then((res) => {
            setPins(res);
          });
        }
      });
    }
  };

  useEffect(() => {
    fetchPinDetails();
  }, [pinId]);

  const addComment = () => {
    if (comment) {
      setAddingComment(true);

      client
        .patch(pinId)
        .setIfMissing({ comments: [] })
        .insert('after', 'comments[-1]', [{ comment, _key: uuidv4(), postedBy: { _type: 'postedBy', _ref: user._id } }])
        .commit()
        .then(() => {
          fetchPinDetails();
          setComment('');
          setAddingComment(false);
        });
    }
  };

  const Support = () => {
    setSupport(true);
  }

  if (!pinDetail) {
    return (
      <Spinner message="Showing pin" />
    );
  }

//   const Input = ({placeholder, name, type, value, handleChange}) => (
//     <input 
//         placeholder={placeholder}
//         type = {type}
//         step = "0.0001"
//         value={value}
//         onChange={(e) => handleChange(e, name)}
//         className ="my-2 w-full rounded-sm p-2  text-sm "
//     />
// );


const sendTransaction = async () => {
  try {
    if(!ethereum) return alert("Please install MetaMask");
    // const { amount, message} = formData;
    const transactionContract = getEthereumContract();
    const parsedAmount = ethers.utils.parseEther(amount);
    console.log(user)

    await ethereum.request({
        method: 'eth_sendTransaction',
        params: [{
            from: user.userName,
            to: pinDetail?.postedBy.userName,
            gas: '0x5208',
            value: parsedAmount._hex,
        }]
    })

    const transactionHash = await transactionContract.addtoBlockchain( parsedAmount, message);

    setIsLoading(true);
    console.log(`Loading : ${transactionHash.hash}`);
    await transactionHash.wait();
    setIsLoading(false);
    console.log(`Success : ${transactionHash.hash}`);

    // const transactionCount = await transactionContract.getTransactionCount();
    

} catch (error) {
    console.log(error);

    throw new Error("No ethereum object.")
}
}

// const handleChange = (e, name) => {
//   setFormData((prevState) => ({...prevState, [name]: e.target.value}));
// } 

const handleSubmit = (e) => {
  // const { amount, message} = formData;

        e.preventDefault();

        if( !amount  || !message){
            return alert("Please fill all the fields");
        } else {
            sendTransaction();
        }
}

  return (
    <>
    <div className='flex xl-flex-row flex-col m-auto bg-white' style={{maxWidth:'1500px', borderRadius:'32px'}}>
      <div className='flex justify-center items-center md:items-start flex-initial'>
        <img
          src={pinDetail?.image && urlFor(pinDetail.image).url()}
          className="rounded-t-3xl rounded-b-lg"
          alt="user-post"
         />
      </div>
      <div className="w-full p-5 flex-1 xl:min-w-620">
        <div className="flex items-center justify-between">
          <div className="flex gap-2 items-center">
            <a
              href={`${pinDetail.image.asset.url}?dl=`}
              download
              className="bg-secondaryColor p-2 text-xl rounded-full flex items-center justify-center text-dark opacity-75 hover:opacity-100"
            >
              <MdDownloadForOffline />
            </a>
          </div>
            <a href={pinDetail.destination} target="_blank" rel="noreferrer">
                {pinDetail.destination?.slice(8,20)}
            </a>
        </div>
        <div>
              {support ? <div></div> : <button
                type="button"
                className="mt-5 bg-blue-500 text-white rounded-full px-3 py-2 font-semibold text-base outline-none"
                onClick={Support}
              >
                Support Creator
              </button>}
              {support  ?
              <div className="p-5 sm:w-96 w-full flex flex-col justify-start items-center ">
              <p>Amount</p>
              <input
                className=" my-2 w-full rounded-sm p-2  text-sm border-gray-100 outline-none border-2 focus:border-gray-300"
                type="number"
                placeholder="Amount (ETH)"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
              <span>Message</span>
              <input
                className=" my-2 w-full rounded-sm p-2  text-sm border-gray-100 outline-none border-2 focus:border-gray-300"
                type="text"
                placeholder="Enter message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
                        {/* <Input placeholder="Amount (ETH)" name="amount" type='number' handleChange={handleChange} value={formData.amount}/>
                        <Input placeholder="Enter message" name="message" type='text' handleChange={handleChange} value={formData.message} /> */}

                        <div className="h-[1px] w-full bg-gray-100 my-2"/>

                        {isLoading ? (<Spinner />) : (<button type='button' onClick={handleSubmit} className=' w-full mt-5 bg-blue-500 text-white rounded-full px-3 py-2 font-semibold text-base outline-noner'>Send Now</button>)}
                    </div>
              :  <div></div>}
              <h1 className="text-4xl font-bold break-words mt-3">
                {pinDetail.title}
              </h1>
              <p className="mt-3">{pinDetail.about}</p>
        </div>
        <Link to={`/user-profile/${pinDetail?.postedBy._id}`} className="flex gap-2 mt-5 items-center bg-white rounded-lg ">
              <img src={pinDetail?.postedBy.image} className="w-10 h-10 rounded-full" alt="user-profile" />
              <p className="font-bold">{pinDetail?.postedBy.userName}</p>
        </Link>
        <h2 className="mt-5 text-2xl">Comments</h2>
            <div className="max-h-370 overflow-y-auto">
              {pinDetail?.comments?.map((item) => (
                <div className="flex gap-2 mt-5 items-center bg-white rounded-lg" key={item.comment}>
                  <img
                    src={item.postedBy?.image}
                    className="w-10 h-10 rounded-full cursor-pointer"
                    alt="user-profile"
                  />
                  <div className="flex flex-col">
                    <p className="font-bold">{item.postedBy?.userName}</p>
                    <p>{item.comment}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex flex-wrap mt-6 gap-3">
            <Link to={`/user-profile/${user._id}`}>
                <img src={user.image} className="w-10 h-10 rounded-full cursor-pointer" alt="user-profile" />
              </Link>
              <input
                className=" flex-1 border-gray-100 outline-none border-2 p-2 rounded-2xl focus:border-gray-300"
                type="text"
                placeholder="Add a comment"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
              <button
                type="button"
                className="bg-red-500 text-white rounded-full px-6 py-2 font-semibold text-base outline-none"
                onClick={addComment}
              >
                {addingComment ? 'Doing...' : 'Done'}
              </button>
            </div>
      </div>
    </div>
    {pins?.length > 0 ? (
      <>
        <h2 className='text-center font-bold text-2xl mt-8 mb-4'>
          More Like This
        </h2>
        <MasonryLayout pins = {pins} />
      </>
    ):(
      <Spinner message="Loading more pins" />
    )}
    </>
  )
}

export default Pindetail